module.exports = __webpack_public_path__ + "static/media/loader.e95e6e2c.gif";